module.exports = {
  pleaseWait: 'Please wait',
  loadMore: 'Pull up to load more',
  loadMore2: 'No more data',
  FAQ: 'FAQ',
  TC: 'T&C',
  Login: 'Login',
  getCode: 'Send OTP',
  loginTips: 'Enter your phone number',
  phoneNumber: 'Phone Number',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Subscribe: 'Subscribe',
  re_sub_tip: 'You have unsubscribed?',
  subscribe: 'Subscribe',
  otpTips: 'Please enter the OTP',
  enter_otp: 'Please enter the OTP'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js